export default __webpack_public_path__ + "f13af4087418244366f84b718817833c.png";